import { BlocksInfoItem } from "./Blocks";
import { type Unit } from "./UnitSelect";
import { meterToFeet } from "../../hooks/meterToFeet";
import type { World } from "src/types/World";
import type { Building } from "src/types/Building";
import { useTranslation } from "src/translations";

export function BlocksInfo(props: {
  design: World;
  unit: Unit;
  selectedBuilding: Building | null;
}) {
  const metrics = props.selectedBuilding?.metrics ?? props.design.architecturalMetrics;
  const unitCount = metrics.ApartmentQuantityTotal;
  const moduleCount =
    props.selectedBuilding?.metrics.ModuleQuantityTotal ??
    props.design.architecturalMetrics.ModuleQuantityTotal;

  const nia =
    props.selectedBuilding?.metrics.NIATotal ?? props.design.architecturalMetrics.NIATotal;

  const gia =
    props.selectedBuilding?.metrics.GIATotal ?? props.design.architecturalMetrics.GIATotal;

  const { t } = useTranslation();

  return (
    <div className="w-full flex items-center justify-evenly p-3">
      <BlocksInfoItem label={t("metrics.blocksUnits")} value={unitCount} />
      <BlocksInfoItem label={t("metrics.blocksModules")} value={moduleCount} />
      <BlocksInfoItem
        label={t("design.nia")}
        value={props.unit === "sqm" ? nia : meterToFeet(nia)}
        unit={props.unit}
      />
      <BlocksInfoItem
        label={t("design.gia")}
        value={props.unit === "sqm" ? gia : meterToFeet(gia)}
        excludeSeperator={true}
        unit={props.unit}
      />
    </div>
  );
}
